"use client";

import { trackEvent } from "@/lib/track.functions";

/** Product-intent events we care about today. */
export type TrackName =
  | "pro_teaser_click"
  | "upgrade_sheet_open"
  | "upgrade_request_submitted"
  | "upgrade_pricing_link_click"
  // Activation + retention funnel (drives the PMF panel in /admin)
  | "signup"
  | "today_viewed"
  | "person_added"
  | "onboarding_completed"
  | "draft_copied"
  | "note_sent"
  | "touch_logged"
  | "person_opened"
  | "boost_run"
  | "feedback_submitted"
  | "coach_nudge_shown"
  | "coach_nudge_acted"
  | "coach_nudge_dismissed"
  | "welcome_tour_completed"
  | "qa_report_submitted";

/**
 * Fire-and-forget analytics. Never blocks the UI and never throws — a failed
 * event must not break an upgrade flow.
 */
export function track(
  name: TrackName,
  props?: { source?: string; plan?: string; [k: string]: unknown },
) {
  if (typeof window === "undefined") return;
  const { source, plan, ...rest } = props ?? {};
  void Promise.resolve(
    trackEvent({ data: { name, source, plan, props: rest } }),
  ).catch(() => {});
}
